import React from "react";

export default function RincianPiutang({
  tahun,
  setTahun,
  rincianpiutangepnbp,
  rincianpiutangkerjasamabu,
  rincianpiutangpendapatanlainlain,
}) {
  const [openTab, setOpenTab] = React.useState(1);

  const thisYear = new Date().getFullYear();

  const increaseTahun = () => {
    if (tahun + 1 <= thisYear) {
      setTahun((inputTahun) => inputTahun + 1);
    }
  };

  const decreaseTahun = () => {
    if (tahun > 2019) {
      setTahun((inputTahun) => inputTahun - 1);
    }
  };

  const getClassLabelStatusPiutang = (statusPiutang) => {
    let labelClass =
      "text-[10px] md:text-xs font-semibold px-1 md:px-2 py-1 rounded-md ";
    switch (statusPiutang) {
      case 1:
        labelClass += "bg-danger-light text-danger";
        break;
      case 2:
        labelClass += "bg-warning-light text-warning";
        break;
      default:
        labelClass += "bg-gray-dark text-white";
    }
    return labelClass;
  };

  const getClassLabelKlasifikasiPiutang = (klasifikasiPiutang) => {
    let labelClass =
      "text-[10px] md:text-xs font-semibold px-1 md:px-2 py-1 rounded-md capitalize ";
    switch (klasifikasiPiutang) {
      case "MACET":
        labelClass += "bg-danger-light text-danger";
        break;
      case "DIRAGUKAN":
        labelClass += "bg-warning-light text-warning";
        break;
      case "KURANG LANCAR":
        labelClass += "bg-secondary-fifth text-secondary";
        break;
      case "LANCAR":
        labelClass += "bg-primary-fourth text-success";
        break;
      case "LUNAS":
        labelClass += "bg-primary-fourth text-success";
        break;
      default:
        labelClass += "bg-gray-dark text-white";
    }
    return labelClass;
  };

  return (
    <>
      <div className="w-full rounded-lg border border-neutral-300 bg-gray-light">
        <div className="grid grid-cols-1 md:grid-cols-2 px-4 py-4">
          <div className="self-center order-last md:order-first mt-2 md:mt-0">
            <div className="flex flex-row justify-center md:justify-start">
              <button
                onClick={decreaseTahun}
                type="button"
                className="px-2 md:px-3 py-1 md:py-2 mr-2 last:mr-0 bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300"
              >
                <svg
                  className="w-4 md:w-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>

              <p className="flex-1 md:flex-none mr-2 last:mr-0 p-1 md:p-2 text-center text-sm md:text-base bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300">
                {tahun}
              </p>

              <button
                onClick={increaseTahun}
                type="button"
                className="px-2 md:px-3 py-1 md:py-2 mr-2 last:mr-0 bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300"
              >
                <svg
                  className="w-4 md:w-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
          <div className="self-center">
            <ul
              className="flex list-none flex-wrap justify-start md:justify-end"
              role="tablist"
            >
              <li className="mr-2 last:mr-0 text-center flex-1 md:flex-none">
                <a
                  className={
                    "text-sm md:text-base font-semibold p-2 shadow-lg border border-neutral-300 rounded-lg block leading-normal duration-300 " +
                    (openTab === 1
                      ? "text-white bg-primary-main"
                      : "text-primary-main bg-white")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTab(1);
                  }}
                  data-toggle="tab"
                  href="#kpuuso"
                  role="tablist"
                >
                  KPU/USO
                </a>
              </li>

              <li className="mr-0 md:mr-2 last:mr-0 text-center flex-1 md:flex-none">
                <a
                  className={
                    "text-sm md:text-base font-semibold p-2 shadow-lg border border-neutral-300 rounded-lg block leading-normal duration-300 " +
                    (openTab === 2
                      ? "text-white bg-primary-main"
                      : "text-primary-main bg-white")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTab(2);
                  }}
                  data-toggle="tab"
                  href="#kerjasamabu"
                  role="tablist"
                >
                  Kerjasama BU
                </a>
              </li>

              <li className="mr-2 last:mr-0 text-center flex-1 md:flex-none">
                <a
                  className={
                    "text-sm md:text-base last:mt-2 md:last:mt-0 font-semibold p-2 shadow-lg border border-neutral-300 rounded-lg block leading-normal duration-300 " +
                    (openTab === 3
                      ? "text-white bg-primary-main"
                      : "text-primary-main bg-white")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTab(3);
                  }}
                  data-toggle="tab"
                  href="#pendapatanlainlain"
                  role="tablist"
                >
                  Penerimaan Lain-lain
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-warp">
          <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-10 border-t border-b border-neutral-300">
            <div className="flex-auto">
              <div className="tab-content tab-space">
                <div className={openTab === 1 ? "block" : "hidden"} id="kpuuso">
                  <div className="overflow-x-scroll md:overflow-x-hidden">
                    <table className="table-auto min-w-full">
                      <tbody>
                        {rincianpiutangepnbp.length !== 0 ? (
                          rincianpiutangepnbp.map((value, index) => {
                            return (
                              <tr className="odd:bg-primary-fifth/40 even:bg-white border-b border-b-neutral-300 last:border-b-0">
                                <td className="p-2 md:p-4 font-semibold">
                                  <div className="flex rounded-full bg-white border border-gray-dark w-8 h-8 md:w-10 md:h-10 justify-center">
                                    <p className="pt-1 md:pt-2 text-sm md:text-base">
                                      {index + 1}
                                    </p>
                                  </div>
                                </td>
                                <td className="p-2 md:p-4">
                                  <p className="text-sm md:text-base font-medium">
                                    {value.nama_perusahaan}
                                  </p>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Wajib Bayar
                                  </p>
                                </td>
                                <td className="p-2 md:p-4">
                                  <p className="text-sm md:text-base font-medium">
                                    {value.tahun_buku}
                                  </p>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Tahun Buku
                                  </p>
                                </td>
                                <td className="p-2 md:p-4">
                                  <p className="text-sm md:text-base font-medium">
                                    {value.nilai_piutang.toLocaleString()}
                                  </p>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Nilai Piutang
                                  </p>
                                </td>
                                <td className="p-2 md:p-4">
                                  <p className="text-sm md:text-base font-medium">
                                    {value.tanggal_piutang}
                                  </p>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Tanggal Piutang
                                  </p>
                                </td>
                                <td className="p-2 md:p-4">
                                  <span
                                    className={getClassLabelStatusPiutang(
                                      value.status_piutang
                                    )}
                                  >
                                    {value.status_piutang === 2
                                      ? "Mengangsur"
                                      : "Belum Bayar"}
                                  </span>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Status Piutang
                                  </p>
                                </td>
                                <td className="p-2 md:p-4">
                                  <span
                                    className={getClassLabelKlasifikasiPiutang(
                                      value.klasifikasi_piutang
                                    )}
                                  >
                                    {value.klasifikasi_piutang.toLowerCase()}
                                  </span>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Klasifikasi Piutang
                                  </p>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr className="odd:bg-primary-fifth/40 even:bg-white border-b border-b-neutral-300 last:border-b-0">
                            <td className="p-2 md:p-4">
                              <p className="text-sm md:text-base text-gray-dark text-center font-medium">
                                Data Piutang Tidak Ditemukan
                              </p>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  className={openTab === 2 ? "block" : "hidden"}
                  id="kerjasamabu"
                >
                  <div className="overflow-x-scroll md:overflow-x-hidden">
                    <table className="table-auto min-w-full">
                      <tbody>
                        {rincianpiutangkerjasamabu.length !== 0 ? (
                          rincianpiutangkerjasamabu.map((value, index) => {
                            return (
                              <tr className="odd:bg-primary-fifth/40 even:bg-white border-b border-b-neutral-300 last:border-b-0">
                                <td className="p-2 md:p-4 font-semibold">
                                  <div className="flex rounded-full bg-white border border-gray-dark w-10 h-10 justify-center">
                                    <p className="pt-2">{index + 1}</p>
                                  </div>
                                </td>
                                <td className="p-2 md:p-4">
                                  <p className="text-sm md:text-base font-medium">
                                    {value.nama_perusahaan}
                                  </p>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Nama Perusahaan
                                  </p>
                                </td>
                                <td className="p-2 md:p-4">
                                  <p className="text-sm md:text-base font-medium">
                                    {value.nilai_piutang.toLocaleString()}
                                  </p>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Nilai Piutang
                                  </p>
                                </td>
                                <td className="p-2 md:p-4">
                                  <p className="text-sm md:text-base font-medium">
                                    {value.nomor_terjadinya_piutang.toLocaleString()}
                                  </p>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Nomor Terjadinya Piutang
                                  </p>
                                </td>
                                <td className="p-2 md:p-4">
                                  <p className="text-sm md:text-base font-medium">
                                    {value.tanggal_piutang}
                                  </p>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Tanggal Piutang
                                  </p>
                                </td>
                                <td className="p-2 md:p-4">
                                  <span
                                    className={getClassLabelStatusPiutang(
                                      value.status_piutang
                                    )}
                                  >
                                    {value.status_piutang === 2
                                      ? "Mengangsur"
                                      : "Belum Bayar"}
                                  </span>
                                  <p className="text-xs md:text-sm text-gray-dark font-medium">
                                    Status Piutang
                                  </p>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr className="odd:bg-primary-fifth/40 even:bg-white border-b border-b-neutral-300 last:border-b-0">
                            <td className="p-2 md:p-4">
                              <p className="text-sm md:text-base text-gray-dark text-center font-medium">
                                Data Piutang Tidak Ditemukan
                              </p>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  className={openTab === 3 ? "block" : "hidden"}
                  id="pendapatanlainlain"
                >
                  <div className="overflow-x-scroll md:overflow-x-hidden">
                    <table className="table-auto min-w-full">
                      <tbody>
                        {rincianpiutangpendapatanlainlain.length !== 0 ? (
                          rincianpiutangpendapatanlainlain.map(
                            (value, index) => {
                              return (
                                <tr className="odd:bg-primary-fifth/40 even:bg-white border-b border-b-neutral-300 last:border-b-0">
                                  <td className="p-2 md:p-4 font-semibold">
                                    <div className="flex rounded-full bg-white border border-gray-dark w-10 h-10 justify-center">
                                      <p className="pt-2">{index + 1}</p>
                                    </div>
                                  </td>
                                  <td className="p-2 md:p-4">
                                    <p className="text-sm md:text-base font-medium">
                                      {value.nama_perusahaan}
                                    </p>
                                    <p className="text-xs md:text-sm text-gray-dark font-medium">
                                      Nama Perusahaan
                                    </p>
                                  </td>
                                  <td className="p-2 md:p-4">
                                    <p className="text-sm md:text-base font-medium">
                                      {value.nilai_piutang.toLocaleString()}
                                    </p>
                                    <p className="text-xs md:text-sm text-gray-dark font-medium">
                                      Nilai Piutang
                                    </p>
                                  </td>
                                  <td className="p-2 md:p-4">
                                    <p className="text-sm md:text-base font-medium">
                                      {value.nomor_terjadinya_piutang.toLocaleString()}
                                    </p>
                                    <p className="text-xs md:text-sm text-gray-dark font-medium">
                                      Nomor Terjadinya Piutang
                                    </p>
                                  </td>
                                  <td className="p-2 md:p-4">
                                    <p className="text-sm md:text-base font-medium">
                                      {value.tanggal_piutang}
                                    </p>
                                    <p className="text-xs md:text-sm text-gray-dark font-medium">
                                      Tanggal Piutang
                                    </p>
                                  </td>
                                  <td className="p-2 md:p-4">
                                    <span
                                      className={getClassLabelStatusPiutang(
                                        value.status_piutang
                                      )}
                                    >
                                      {value.status_piutang === 2
                                        ? "Mengangsur"
                                        : "Belum Bayar"}
                                    </span>
                                    <p className="text-xs md:text-sm text-gray-dark font-medium">
                                      Status Piutang
                                    </p>
                                  </td>
                                  <td className="p-2 md:p-4">
                                    <span
                                      className={getClassLabelKlasifikasiPiutang(
                                        value.klasifikasi_piutang
                                      )}
                                    >
                                      {value.klasifikasi_piutang.toLowerCase()}
                                    </span>
                                    <p className="text-xs md:text-sm text-gray-dark font-medium">
                                      Klasifikasi Piutang
                                    </p>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : (
                          <tr className="odd:bg-primary-fifth/40 even:bg-white border-b border-b-neutral-300 last:border-b-0">
                            <td className="p-2 md:p-4">
                              <p className="text-sm md:text-base text-gray-dark text-center font-medium">
                                Data Piutang Tidak Ditemukan
                              </p>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
